// Test Cases
import { getLocalTimezoneAbbreviation } from '../../utils';

export const TEST_CASE_PROFILE_NAME = 'profileName';
export const TEST_CASE_ID = 'testCaseId';
export const TEST_CASE_STATUS = 'status';
export const TEST_CASE_CREATED_AT = 'createdAt';
export const TEST_CASE_ACTION = 'action';

// Video Ad Traces
export const TRACE_DEVICE_NAME = 'deviceName';
export const TRACE_INTEGRATION = 'integration';
export const TRACE_DEVICE_DISTRIBUTOR_NAME = 'deviceDistributor';
export const TRACE_CONTENT_PARTNER_NAME = 'contentPartnerName';
export const TRACE_CONTENT_PARTNER_IDENTIFIER = 'contentPartnerIdentifier';
export const TRACE_CONTENT_DISTRIBUTOR_NAME = 'contentDistributor';
export const TRACE_POD = 'pod';
export const TRACE_TIME = 'time';
export const TRACE_STATUS = 'status';
export const TRACE_SERIES_NAME = 'seriesName';
export const TRACE_SERIES_ID = 'seriesIdentifier';
export const TRACE_CONTENT_TITLE = 'contentTitle';
export const TRACE_COUNTRY = 'country';
export const TRACE_AD_SERVER = 'adServer';
export const TRACE_PUBLISHER = 'publisher';
export const TRACE_ZIPKIN_TRACE_ID = 'zipkinTraceId';

export const DEVICE_TITLE = 'Device';
export const INTEGRATION_TITLE = 'Integration';
export const DEVICE_DISTRIBUTOR_TITLE = 'Device Distributor';
export const CONTENT_INFO_TITLE = 'Content Info';
export const CONTENT_DISTRIBUTOR_TITLE = 'Content Distributor';
export const POD_TITLE = 'Pod';
export const TIME_TITLE = `Time (${getLocalTimezoneAbbreviation()})`;
export const STATUS_TITLE = 'Status';
export const COUNTRY_TITLE = 'Country';
export const AD_SERVER_TITLE = 'Ad Server';
export const PUBLISHER_TITLE = 'Publisher';
/** Column title for distributed trace id (links to Zipkin when internal permission allows). */
export const TRACE_ID_COLUMN_TITLE = 'Trace ID';

// Time Misc.
export const OUTPUT_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss';

// Accounts
export const DISNEY_PLUS_PUBLISHER = 'DISNEY_PLUS';
export const HULU_PUBLISHER = 'HULU';
export const HULU_PLUS_PUBLISHER = 'HULU_PLUS';
export const ESPN_PUBLISHER = 'ESPN';
export const OFF_PLATFORM_PUBLISHER = 'OFF_PLATFORM';
export const NEWS_ENT_PUBLISHER = 'NEWS_ENT';
export const ROKU_FAST_PUBLISHER = 'ROKU';
export const FUBO_PUBLISHER = 'FUBO_TV';

// Permissions for accessing Account tiles
export const TRACE_DISNEY_PLUS_ACCOUNT = 'TRACE_DISNEY_PLUS_ACCOUNT';
export const TRACE_HULU_ACCOUNT = 'TRACE_HULU_ACCOUNT';
export const TRACE_HULU_PLUS_ACCOUNT = 'TRACE_HULU_PLUS_ACCOUNT';
export const TRACE_ESPN_ACCOUNT = 'TRACE_ESPN_ACCOUNT';
export const TRACE_OFF_PLATFORM_ACCOUNT = 'TRACE_OFF_PLATFORM_ACCOUNT';
export const TRACE_NEWS_ENT_ACCOUNT = 'TRACE_NEWS_ENT_ACCOUNT';
export const TRACE_FUBO_ACCOUNT = 'TRACE_FUBO_ACCOUNT';
export const TRACE_ROKU_ACCOUNT = 'TRACE_ROKU_ACCOUNT';
